import type { WalletInterface } from '@api';

import type { WalletConnectType } from './walletsConfig';

export const getConnectedWallet = (wallets: WalletInterface[], connectType: WalletConnectType) => {
  return wallets?.find((wallet) => connectType === wallet.attributes.network);
};
